var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container as DumbContainer, useContainer, minContainerSize, } from '@tribeplatform/react-ui-kit/Layout';
import { useBlock, useSlate } from '../../hooks/index.js';
import { isColumnBlock, isContainerBlock, isDeprecatedBlock } from './utils.js';
export const ContainerBlock = (_a) => {
    var { size: inputSize, maxSize: inputMaxSize, direction: inputDirection, columns, children, smColumns } = _a, rest = __rest(_a, ["size", "maxSize", "direction", "columns", "children", "smColumns"]);
    const { compiledSlate: { blocks }, } = useSlate();
    const { block: { name, children: blockChildren }, } = useBlock();
    const { size: parentSize } = useContainer();
    const isColumn = isColumnBlock(name) && !!columns;
    const isDeprecated = isDeprecatedBlock(name);
    const items = React.Children.toArray(children);
    if (items.length === 0)
        return null;
    const direction = isColumn ? 'grid' : inputDirection;
    const smOrders = isColumn && (smColumns || [columns.findIndex(({ main }) => main)]);
    const size = minContainerSize(inputSize, parentSize);
    const maxSize = inputMaxSize || inputSize || (isDeprecated ? 'lg' : undefined);
    const childrenSizes = [];
    if (isColumn) {
        blockChildren
            .map((child, idx) => ({ block: blocks[child], idx }))
            .filter(({ block }) => { var _a; return ((_a = block.children) === null || _a === void 0 ? void 0 : _a.length) > 0; })
            .forEach(({ block, idx }) => {
            var _a;
            if (isContainerBlock(block)) {
                childrenSizes.push(((_a = block.props) === null || _a === void 0 ? void 0 : _a.size) || size);
            }
            else {
                childrenSizes.push(columns[idx].main ? 'md' : 'sm');
            }
        });
    }
    return (React.createElement(DumbContainer, Object.assign({ size: isColumn ? 'lg' : size, maxSize: maxSize, childrenSizes: childrenSizes, direction: direction }, rest), isColumn
        ? items.map((item, idx) => {
            var _a;
            const smOrder = smOrders.findIndex(smIdx => smIdx === idx);
            const hide = ((_a = blocks[blockChildren[idx]].children) === null || _a === void 0 ? void 0 : _a.length) === 0;
            return (React.createElement(DumbContainer, { key: blockChildren[idx], size: columns[idx].main ? 'md' : 'sm', maxSize: columns[idx].main ? 'full' : 'md', direction: "vertical", order: { default: idx + 1, sm: smOrder > -1 ? smOrder + 1 : 0 }, hide: { default: hide, sm: hide || smOrder === -1 } }, item));
        })
        : items));
};
//# sourceMappingURL=Block.js.map